module.exports = __webpack_public_path__ + "static/img/ic_jrsb.bf406fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_jrsb.png
// module id = u6gJ
// module chunks = 19